/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.Booking.ConsultationList.ListStoresView.Headline';
export const PlaceholderText = 'Website.Booking.ConsultationList.ListStoresView.PlaceholderText';
export const SearchSubmit = 'Website.Booking.ConsultationList.ListStoresView.SearchSubmit';
export const InputLabel = 'Website.Booking.ConsultationList.ListStoresView.InputLabel';
export const GeoLocationButton = 'Website.Booking.ConsultationList.ListStoresView.GeoLocationButton';
export const GeoLocationError = 'Website.Booking.ConsultationList.ListStoresView.GeoLocationError';
export const ClosestStoreHasNoBookings = 'Website.Booking.ConsultationList.ListStoresView.ClosestStoreHasNoBookings';
export const AlternativeStoresHeadline = 'Website.Booking.ConsultationList.ListStoresView.AlternativeStoresHeadline';
export const Reset = 'Website.Booking.ConsultationList.ListStoresView.Reset';
export const Submit = 'Website.Booking.ConsultationList.ListStoresView.Submit';
export const NoHits = 'Website.Booking.ConsultationList.ListStoresView.NoHits';
